import type { ActiveFilterChip } from '@/components/ui/list-filters';
import { industryLabel, regionLabel } from './constants';

/** Company-profile filter values (ADR-108); `'all'` = not filtering. */
export interface CompanyProfileFilterValues {
  industry: string;
  region: string;
  technology: string;
}

export const NO_PROFILE_FILTERS: CompanyProfileFilterValues = {
  industry: 'all',
  region: 'all',
  technology: 'all',
};

/** The query params for the backend filters (Companies and Leads share them). */
export function profileFilterParams(v: CompanyProfileFilterValues) {
  return {
    industry: v.industry === 'all' ? undefined : v.industry,
    region: v.region === 'all' ? undefined : v.region,
    technology: v.technology === 'all' ? undefined : v.technology,
  };
}

export function profileFilterChips(
  v: CompanyProfileFilterValues,
  onChange: (next: CompanyProfileFilterValues) => void,
): ActiveFilterChip[] {
  const chips: ActiveFilterChip[] = [];
  if (v.industry !== 'all') {
    chips.push({
      key: 'industry',
      label: `Industry: ${industryLabel(v.industry)}`,
      onRemove: () => onChange({ ...v, industry: 'all' }),
    });
  }
  if (v.region !== 'all') {
    chips.push({
      key: 'region',
      label: `Region: ${regionLabel(v.region)}`,
      onRemove: () => onChange({ ...v, region: 'all' }),
    });
  }
  if (v.technology !== 'all') {
    chips.push({
      key: 'technology',
      label: `Tech: ${v.technology}`,
      onRemove: () => onChange({ ...v, technology: 'all' }),
    });
  }
  return chips;
}
